import { useEffect, useRef } from 'react';
import { setTopLoadingController } from './topLoadingController';

const TopLoadingBar = () => {
    const barRef = useRef(null);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const el = barRef.current;
        if (!el) return;

        function start() {
            if (!el) return;
            clearTimeout(timeoutRef.current);
            el.style.transition = 'none';
            el.style.width = '0%';
            el.style.opacity = '1';
            // Force reflow
            void el.offsetWidth;
            el.style.transition = 'width 600ms cubic-bezier(.2,.8,.2,1)';
            el.style.width = '80%';
        }

        function done() {
            if (!el) return;
            clearTimeout(timeoutRef.current);
            el.style.transition = 'width 250ms ease-in, opacity 300ms ease-in 200ms';
            el.style.width = '100%';
            timeoutRef.current = setTimeout(() => {
                el.style.opacity = '0';
                // reset after fade
                setTimeout(() => {
                    el.style.width = '0%';
                }, 300);
            }, 200);
        }

        setTopLoadingController({ start, done });

        return () => {
            clearTimeout(timeoutRef.current);
            setTopLoadingController({ start: () => {}, done: () => {} });
        };
    }, []);

    return (
        <div aria-hidden="true" className="pointer-events-none fixed inset-x-0 top-0 z-50">
            <div ref={barRef} style={{ height: 3, width: '0%', opacity: 0 }} className="bg-primary origin-left" />
        </div>
    );
};

export default TopLoadingBar;
